import {
  ComponentRenderMap,
  SectionRenderMap,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/types";
import { ResultsDropdownWrapper } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultsDropdownWrapper";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { SDUIHeaderRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Header/SDUIHeaderRenderer";
import { SDUISimpleActionBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/SDUISimpleActionBannerRenderer";
import { SDUISearchSuggestionsRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/SearchSuggestions/SDUISearchSuggestionsRenderer";
import { SDUIRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SDUIRenderer/SDUIRenderer";
import { SDUILayoutSectionRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/LayoutSection/SDUILayoutSectionRenderer";
import { useQuery as useSearchSuggestionsEmptyStateQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/search/empty-page-suggestions/retailerToken/get-hooks";
import { Spacer } from "@faire/web/slate/spacing/spacing";
import { useRef } from "react";

const componentRenderers: ComponentRenderMap = {
  search_suggestions_component: {
    active: SDUISearchSuggestionsRenderer,
  },
  simple_action_banner_component: {
    active: SDUISimpleActionBannerRenderer,
  },
  header_component: {
    active: SDUIHeaderRenderer,
  },
};
const sectionRenderers: SectionRenderMap = {
  layout_section: SDUILayoutSectionRenderer,
};

export const SDUISearchDropdownEmptyState = ({
  parent,
}: {
  parent: HTMLDivElement | null;
}) => {
  const retailerToken = getRetailer()?.token ?? "";
  const { data } = useSearchSuggestionsEmptyStateQuery(retailerToken);
  const dropdownContainerRef = useRef<HTMLDivElement>(null);

  if (!data?.view_layout) {
    return null;
  }

  const { view_layout } = data;

  return (
    <ResultsDropdownWrapper
      parent={parent}
      dropdownContainerRef={dropdownContainerRef}
      data-test-id="SDUI-search-dropdown-empty-state"
    >
      <SDUIRenderer
        componentRenderers={componentRenderers}
        sectionRenderers={sectionRenderers}
        viewLayout={view_layout!}
      />
      <Spacer size="1x" />
    </ResultsDropdownWrapper>
  );
};
